import React, { Component } from "react";
import styles from "./Neighbourhood.scss";
import classnames from "classnames";
import { Doughnut } from "react-chartjs-2";
import axios from "axios";

class NeighbourhoodTemplate extends Component {
	constructor(props) {
		super(props);
		this.state = {
			neighbourhood: undefined,
			chart_options: { legend: { display: false } },
			age_data: undefined,
			path: undefined,
			id: undefined
		};
	}

	componentDidMount() {
		this.getNeighbourhoodData();
	}

	getNeighbourhoodData = () => {
		let id = undefined;
		if (!this.props.id) {
			const urlParams = new URLSearchParams(window.location.search);
			id = urlParams.get('id');
		} else {
			id = this.props.id
		}
		axios
			.post("/api/neighbourhood_data/id/", {
				neighbourhood_id: parseInt(id, 10)
			})
			.then(res => {
				this.setState({
					neighbourhood: res.data,
					age_data: {
						labels: [
							"Age 0-4",
							"Age 5-14",
							"Age 15-19",
							"Age 20-24",
							"Age 25-64",
							"Age 65+"
						],
						datasets: [
							{
								backgroundColor: [
									"#A3C940",// "#7FA9AE",
									"#007D99",// "#50748A",
									"#4D4094",// "#767B4D",
									"#43C2B0",// "#D8D2C4",
									"#FCC328",// "#9D6167",
									"#822470",// "#815374",
									"#4D4D4D"// "#A93439"
								],
								borderColor: "#FFFFFF",
								borderWidth: 1,
								data: [
									res.data["Total Age 0-4"],
									res.data["Total Elementry School Age 5-14"],
									res.data[
										"Total Secondary School Age 15-19"
									],
									res.data["Total Undergrad Age 20-24"],
									res.data["Total Workforce"],
									res.data["Total Retired Age 65-85+"]
								]
							}
						]
					},
					household_data: {
						labels: ["Detached Houses", "Apartment Units"],
						datasets: [
							{
								backgroundColor: [
									"#4D4094",
									"#43C2B0",
									"#A3C940",
									"#007D99",
									"#FCC328",
									"#822470",
									"#4D4D4D"
								],
								borderColor: "#FFFFFF",
								borderWidth: 1,
								data: [
									res.data["Total Attached Houses"],
									res.data["Apartment Building Total"]
								]
							}
						]
					}
				});
			})
			.catch(e => console.log(e));
	};

	redirectToMap = () => {
		var location = window.location.origin;
		if (location.includes("localhost:3000")) {
			window.location.href = `/map/?id=${this.props.id}`
		} else {
			let id = undefined;
			if (this.props.id) {
				id = this.props.id;
			} else {
				const urlParams = new URLSearchParams(window.location.search);
				id = urlParams.get('id');
			}
				window.open(`https://possiblemadehere.org/interest-map/?id=${id}`, '_blank');
		}
	}

	getWSImage = (name) => {
		let walkScoreName;
		let postal = null;
		switch(name) {
			case "Mile Square":
				walkScoreName = "Aylmer Crescent"
			break;
			case "Sutton Mills":
				walkScoreName = "Old Colony Rd"
			break;
			case "Bayridge East":
				walkScoreName = "pimlico pl"
			break;
			case "Henderson":
				walkScoreName = "Glen Castle Rd"
			break;
			case "Gardiners / Meadowbrook":
				walkScoreName = "Tanner Dr"
			break;
			case "Fairway Hills":
				walkScoreName = "old oak rd"
			break;
			case "Inner Harbour":
				walkScoreName = "rideau st"
				postal = "K7K-2Z7"
			break;
			case "St Lawrence North":
				walkScoreName = "john-f-scott-rd"
			break;
			case "Ravensview":
				walkScoreName = "King Pitt rd"
			break;
			case "Sharpton / Glenvale":
				walkScoreName = "King Pitt rd"
			break;
			default:
				walkScoreName = name;
		}
		if(postal) {
			let scores = {
				walk: `//pp.walk.sc/badge/walk/${walkScoreName.replace(/\s+/g, '-').replace(/-\/-/g, '-').toLowerCase()}-Kingston--CA.dash.ON-${postal}.png`,
				transit: `//pp.walk.sc/badge/transit/${walkScoreName.replace(/\s+/g, '-').replace(/-\/-/g, '-').toLowerCase()}-Kingston--CA.dash.ON-${postal}.png`,
				bike: `//pp.walk.sc/badge/bike/${walkScoreName.replace(/\s+/g, '-').replace(/-\/-/g, '-').toLowerCase()}-Kingston--CA.dash.ON-${postal}.png`
			}
			return scores;
	} else {
		let scores = {
			walk: `//pp.walk.sc/badge/walk/${walkScoreName.replace(/\s+/g, '-').replace(/-\/-/g, '-').toLowerCase()}-Kingston--CA.dash.ON.png`,
			transit: `//pp.walk.sc/badge/transit/${walkScoreName.replace(/\s+/g, '-').replace(/-\/-/g, '-').toLowerCase()}-Kingston--CA.dash.ON.png`,
			bike: `//pp.walk.sc/badge/bike/${walkScoreName.replace(/\s+/g, '-').replace(/-\/-/g, '-').toLowerCase()}-Kingston--CA.dash.ON.png`
		}
		return scores;
	}
	}
	render() {
		// Display nothing if neighbourhoods haven't loaded
		if (this.state.neighbourhood === undefined) {
			return <div> </div>;
		} else {
			// If user has searched by tags do this
			if (this.props.selectedTag) {
				let searchTag = this.props.selectedTag;
				let hoodTags = this.state.neighbourhood.Tags.split(",");
				if (hoodTags.includes(searchTag)) {
					return (
								<div className={styles.neighbourhoodContainer}>
							<br/>
								<h2>{this.state.neighbourhood.Name}</h2>
								<div className="row">
									<div className="col-md-12">
										<figure className="figure">
											<img
												src={this.state.neighbourhood.image}
												className="figure-img img-fluid rounded"
												alt={`${
													this.state.neighbourhood.Name
												} capture`}
											/>
											{/*<figcaption class="figure-caption">
												View of {this.state.neighbourhood.Name}{" "}
												neighbourhood
											</figcaption>*/}
										</figure>
									</div>
								</div>
									<div className="row" >
										<div className="col-md-6">
											<h6>Walk Score®</h6>
											<div className={classnames("row", styles.WalkScoreImgs)}>
												<img src={this.getWSImage(this.state.neighbourhood.Name).transit} alt=""/>
												<img src={this.getWSImage(this.state.neighbourhood.Name).walk} alt=""/>
												<img src={this.getWSImage(this.state.neighbourhood.Name).bike} alt=""/>
											</div>
										</div>

										<div className="col-md-6">
											<h6>Tags</h6>
											{this.state.neighbourhood["Tags"]
												.split(",")
												.map((x, key) => (
													<span key={key} className={classnames("badge badge-info", styles.badge)}>
														{x}
													</span>
											))}
										</div>
										<br />
								</div>

								<div className="row">
									<div className="col-md-12">
										<p className={styles.desc}>{this.state.neighbourhood.Description}</p>
									</div>
								</div>

								<div className="row">

									<div className={
										(window.location.pathname !== "/map" &&
										window.location.pathname !== "/map/")
										? "col-md-4"
										: "col-md-6"
									} align="center" >
										<h5>Housing Distribution</h5>
										<Doughnut
											data={this.state.household_data}
											options={this.state.chart_options}
										/>
									</div>

									<div className={
										(window.location.pathname !== "/map" &&
										window.location.pathname !== "/map/")
										? "col-md-4"
										: "col-md-6"
									} align="center" >
										<h5>Age Distribution</h5>
										<Doughnut
											data={this.state.age_data}
											options={this.state.chart_options}
										/>
								</div>

								{(window.location.pathname !== "/map" &&
								window.location.pathname !== "/map/") &&
									<div className={classnames("col-md-4", styles.mapLink)} align="center">
										<a className={classnames(styles.linkToMap)} onClick={this.redirectToMap}>
										<h5>Explore Interactive Map</h5>
										<figure className="figure">
											<img
												src={this.state.neighbourhood.map_image}
												className={classnames("figure-img img-fluid rounded", styles.mapImg)}
												alt={`${
													this.state.neighbourhood.Name
												} capture`}
											/>
										</figure>
										</a>
									</div>
								}

							</div>

								<button
									type="button"
									className={classnames("btn btn-light", styles.button)}
								>
									<a
										href={this.state.neighbourhood.realtor_url}
										target="_blank"
									>
										See Homes on Realtor.ca
									</a>
								</button>

							</div>)
						} else {
							// No neighbourhoods match results
							return <div> </div>
					}
					// User has not searched by tags
					} else {
						return (
						<div className={styles.neighbourhoodContainer}>
						<br/>
							<h2>{this.state.neighbourhood.Name}</h2>
							<div className="row">
								<div className="col-md-12">
									<figure className="figure">
										<img
											src={this.state.neighbourhood.image}
											className="figure-img img-fluid rounded"
											alt={`${
												this.state.neighbourhood.Name
											} capture`}
										/>
										{/*<figcaption class="figure-caption">
											View of {this.state.neighbourhood.Name}{" "}
											neighbourhood
										</figcaption>*/}
									</figure>
								</div>
							</div>
								<div className="row" >
									<div className="col-md-6">
										<h6>Walk Score®</h6>
										<div className={classnames("row", styles.WalkScoreImgs)}>
											<img src={`//pp.walk.sc/badge/transit/${this.state.neighbourhood.Name.replace(/\s+/g, '-').replace(/-\/-/g, '-').toLowerCase()}-Kingston--CA.dash.ON.png`} alt=""/>
											<img src={`//pp.walk.sc/badge/walk/${this.state.neighbourhood.Name.replace(/\s+/g, '-').replace(/-\/-/g, '-').toLowerCase()}-Kingston--CA.dash.ON.png`} alt=""/>
											<img src={`//pp.walk.sc/badge/bike/${this.state.neighbourhood.Name.replace(/\s+/g, '-').replace(/-\/-/g, '-').toLowerCase()}-Kingston--CA.dash.ON.png`} alt=""/>
										</div>
									</div>

									<div className="col-md-6">
										<h6>Tags</h6>
										{this.state.neighbourhood["Tags"]
											.split(",")
											.map((x, key) => (
												<span key={key} className={classnames("badge badge-info", styles.badge)}>
													{x}
												</span>
										))}
									</div>
									<br />
							</div>

							<div className="row">
								<div className="col-md-12">
									<p className={styles.desc}>{this.state.neighbourhood.Description}</p>
								</div>
							</div>

							<div className="row">

								<div className={
									(window.location.pathname !== "/map" &&
									window.location.pathname !== "/map/")
									? "col-md-4"
									: "col-md-6"
								} align="center" >
									<h5>Housing Distribution</h5>
									<Doughnut
										data={this.state.household_data}
										options={this.state.chart_options}
									/>
								</div>

								<div className={
									(window.location.pathname !== "/map" &&
									window.location.pathname !== "/map/")
									? "col-md-4"
									: "col-md-6"
								} align="center" >
									<h5>Age Distribution</h5>
									<Doughnut
										data={this.state.age_data}
										options={this.state.chart_options}
									/>
							</div>

							{(window.location.pathname !== "/map" &&
							window.location.pathname !== "/map/") &&
								<div className={classnames("col-md-4", styles.mapLink)} align="center">
									<a className={classnames(styles.linkToMap)} onClick={this.redirectToMap}>
									<h5>Explore Interactive Map</h5>
									<figure className="figure">
										<img
											src={this.state.neighbourhood.map_image}
											className={classnames("figure-img img-fluid rounded", styles.mapImg)}
											alt={`${
												this.state.neighbourhood.Name
											} capture`}
										/>
									</figure>
									</a>
								</div>
							}

						</div>

							<button
								type="button"
								className={classnames("btn btn-light", styles.button)}
							>
								<a
									href={this.state.neighbourhood.realtor_url}
									target="_blank"
								>
									See Homes on Realtor.ca
								</a>
							</button>

						</div>
					)}
				}
			}
	}

export default NeighbourhoodTemplate;



// WEBPACK FOOTER //
// ./src/components/pages/Neighbourhood/NeighbourhoodTemplate.js